<template>
  <div class="status flex items-center flex-none relative">
    <span
      class="state flex-1 text-center"
      :class="['tag', statusColorClass]"
      v-if="!loading && label"
    >
      <div class="truncate max-w-[14ch]" :class="{ 'whitespace-normal': wrap }">{{ label }}</div>
    </span>
    <Skeleton v-if="loading" width="13ch" height="1.2em" />
  </div>
</template>

<script>
import Skeleton from "primevue/skeleton";

export default {
  name: "Status",
  components: {
    Skeleton,
  },
  props: {
    value: Number,
    label: String,
    inverted: { type: Boolean, default: false },
    wrap: Boolean,
  },
  computed: {
    loading() {
      return !Number.isInteger(this.value);
    },
    statusColorClass() {
      const baseClass = this.inverted ? "" : "-outlined";
      switch (this.value) {
        case 0:
        default:
          return `tag-primary${baseClass}`;
        case 5:
        case 7:
        case 4:
        case 14:
        case 17:
        case 19:
        case 15:
        case 18:
          return `tag-warning${baseClass}`;
        case 11:
        case 16:
          return `structuring tag-pink${baseClass}`;
        case 2:
        case 12:
        case 13:
        case 1:
        case 3:
        case 9:
          return `issued tag-success${baseClass}`;
        case 6:
          return `terminated tag-danger${baseClass}`;
      }
    },
  },
};
</script>
